function trim(value) {
  return typeof value === "string" ? value.trim() : ""
}

function businessClaimId(trackId, uid) {
  const safeTrackId = trim(trackId)
  const safeUid = trim(uid)
  if (!/^[A-Za-z0-9._-]+$/.test(safeTrackId) || !/^[A-Za-z0-9._-]+$/.test(safeUid)) return ""
  return `${safeTrackId}:${safeUid}`
}

function businessClaimPath(trackId) {
  return `/claim-business?track=${encodeURIComponent(trim(trackId))}`
}

function validEmail(value) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
}

function validWebsite(value) {
  if (!value) return true
  try {
    const url = new URL(value)
    return url.protocol === "http:" || url.protocol === "https:"
  } catch (_) {
    return false
  }
}

function validateBusinessClaim(input = {}) {
  const errors = {}
  const trackId = trim(input.trackId)
  const uid = trim(input.uid)
  const claimantName = trim(input.claimantName)
  const role = trim(input.role)
  const businessEmail = trim(input.businessEmail).toLowerCase()
  const businessWebsite = trim(input.businessWebsite)
  const verificationNote = trim(input.verificationNote)

  if (!trackId || !uid || !/^[A-Za-z0-9._-]+$/.test(trackId) || !/^[A-Za-z0-9._-]+$/.test(uid)) errors.form = "The business could not be identified."
  else if (!claimantName) errors.claimantName = "Enter your full name."
  else if (claimantName.length > 120) errors.claimantName = "Name must be 120 characters or fewer."

  if (!role) errors.role = "Tell us your role at the business."
  else if (role.length > 120) errors.role = "Role must be 120 characters or fewer."

  if (!businessEmail || !validEmail(businessEmail)) errors.businessEmail = "Enter a valid business email."
  if (!validWebsite(businessWebsite)) errors.businessWebsite = "Enter a valid http or https website."
  if (verificationNote.length > 2000) errors.verificationNote = "Verification note must be 2,000 characters or fewer."

  return errors
}

function buildBusinessClaim(input, timestamp) {
  const errors = validateBusinessClaim(input)
  if (Object.keys(errors).length) {
    const error = new Error("Business claim is invalid")
    error.fields = errors
    throw error
  }

  return {
    trackId: trim(input.trackId),
    trackName: trim(input.trackName),
    trackSlug: trim(input.trackSlug),
    uid: trim(input.uid),
    accountEmail: trim(input.accountEmail),
    claimantName: trim(input.claimantName),
    role: trim(input.role),
    businessEmail: trim(input.businessEmail).toLowerCase(),
    businessWebsite: trim(input.businessWebsite),
    verificationNote: trim(input.verificationNote),
    status: "pending",
    createdAt: timestamp,
    updatedAt: timestamp,
  }
}

module.exports = {
  buildBusinessClaim,
  businessClaimId,
  businessClaimPath,
  validateBusinessClaim,
}
